import { RestoreNoTransactionError } from '@forest/paywall-core'
import isNetworkError from 'is-network-error'
import { isHTTPError, isTimeoutError } from 'ky'
import type { Platform } from '~/params'

export type RestoreErrorBranch =
  | { kind: 'no_transaction' }
  | { kind: 'owner_uid_conflict'; status: 409 | 412 }
  | { kind: 'forest_account_mismatch' }
  | { kind: 'transaction_expired' }
  | { kind: 'unexpected_http'; status: number }
  | { kind: 'connection' }
  | { kind: 'unexpected' }

export function classifyRestoreError(
  error: unknown,
  platform: Platform,
): RestoreErrorBranch {
  if (error instanceof RestoreNoTransactionError) {
    return { kind: 'no_transaction' }
  }

  if (isHTTPError(error)) {
    const status = error.response.status
    if ((status === 409 || status === 412) && platform !== 'china_android') {
      return { kind: 'owner_uid_conflict', status }
    }
    if (status === 403 && platform !== 'china_android') {
      return { kind: 'forest_account_mismatch' }
    }
    if (
      status === 410 ||
      ((status === 403 || status === 409) && platform === 'china_android')
    ) {
      return { kind: 'transaction_expired' }
    }
    return { kind: 'unexpected_http', status }
  }

  if (isNetworkError(error) || isTimeoutError(error)) {
    return { kind: 'connection' }
  }

  return { kind: 'unexpected' }
}
